import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import "./styles.css";

export interface ProgressBarProps {
    localizedTitle: string;
    currentProgressIndex: number;
    totalNumItems: number;
    localizer: IStringLocalizer;
}

export class ProgressBar extends React.PureComponent<ProgressBarProps> {
    public render() {
        let index = this.props.currentProgressIndex;

        if (index >= this.props.totalNumItems) {
            index = this.props.totalNumItems;
        }

        let percentComplete = 0.0;

        if (this.props.totalNumItems > 0) {
            percentComplete = index / this.props.totalNumItems * 100;
        }

        return (
            <div className="tn-progress-bar">
                <div className="header">
                    <p>
                        {this.props.localizedTitle}
                    </p>
                    <p className="progress-description">
                        {`${this.props.currentProgressIndex}`} {this.props.localizer.localizeString("of")} {`${this.props.totalNumItems}`}
                    </p>
                </div>
                <div className="bar-container">
                    <div className="outline"></div>
                    <div className="bar" style={{ width: `${percentComplete.roundBy(2)}%` }}></div>
                </div>
            </div>
            );
    }
}
